import React, {useContext} from "react";
import OwlCarousel from "react-owl-carousel";
import {Link} from "react-router-dom";
import {SearchOptionsContext} from "../../context/search-options-context";
import logoIcon from "../../assets/images/icons/logo_icon.svg";
import {getBodyTypeImage} from "../../utils/BodyTypeIcons";

const NAV_NEXT = () => `<img src="${logoIcon}" width="42" height="42" style="display:block;" alt=""/>`;
const NAV_PREV = () => `<img src="${logoIcon}" width="42" height="42" style="display:block;transform:rotate(180deg);" alt=""/>`;

function BodyTypesSlider({types, vehicleType}) {
    const title = vehicleType === "DOSTAWCZE" ? "Dostawcze" : "Osobowe";

    if (!types || types.length === 0) return null;

    return (
        <div className="body-types-card">
            <div className="body-types-card-header">
                <h3 className="body-types-card-title">{title}</h3>
                <Link
                    to={{pathname: "/lista-ofert", search: "vehicleTypes=" + vehicleType}}
                    className="body-types-card-btn"
                >
                    ZOBACZ WSZYSTKIE
                    <img src={logoIcon} alt="" className="search-btn-icon"/>
                </Link>
            </div>
            <div className="body-types-slider-wrap">
                <OwlCarousel
                    key={types.join(",")}
                    loop={false}
                    nav={true}
                    dots={false}
                    navText={[NAV_PREV(), NAV_NEXT()]}
                    responsive={{
                        0: {items: 2, margin: 16},
                        480: {items: 3, margin: 20},
                        767: {items: 4, margin: 24},
                        1024: {items: 5, margin: 30}
                    }}
                >
                    {types.map((type, i) => (
                        <Link
                            key={i}
                            to={{
                                pathname: "/lista-ofert",
                                search: "bodyTypes=" + encodeURIComponent(type) + "&vehicleTypes=" + vehicleType
                            }}
                            className="body-types-item"
                        >
                            <div className="body-types-item-img">
                                <img src={getBodyTypeImage(type, vehicleType)} alt={type}/>
                            </div>
                            <span className="body-types-item-label">{type}</span>
                        </Link>
                    ))}
                </OwlCarousel>
            </div>
        </div>
    );
}

function BodyTypes() {
    const searchOptions = useContext(SearchOptionsContext);

    return (
        <section className="body-types-section">
            <div className="container">
                <div className="body-types-header">
                    <h2 className="body-types-heading">Wiele rodzajów nadwozia</h2>
                    <p className="body-types-subheading">
                        W GO-auto znajdziesz auta o różnych nadwoziach.
                    </p>
                </div>
                <BodyTypesSlider types={searchOptions.passengerCars.bodyTypes} vehicleType="OSOBOWE"/>
                <BodyTypesSlider types={searchOptions.deliveryCars.bodyTypes} vehicleType="DOSTAWCZE"/>
            </div>
        </section>
    );
}

export default BodyTypes;
